import { PageProps } from 'gatsby'
import { ComponentProps } from 'react'

import {
  Breadcrumb,
  CategoryDictionary,
  CategoryLayout,
  FilterCategoryLayout,
  FilterSearchLayout,
  FilterSearchResultLayout,
  HtmlLayout,
  IframeLayout,
  Layout,
  SearchPageContext,
  SearchParams,
} from '@karakuri-web/faq-type'

import { CategoryWidget } from '../CategoryWidget'
import { FilterCategoryWidget } from '../FilterCategoryWidget'
import { FilterSearchResultWidget } from '../FilterSearchResultWidget'
import { FilterSearchWidget } from '../FilterSearchWidget'
import { HtmlWidget } from '../HtmlWidget'
import { IframeWidget } from '../IframeWidget'
import { Data } from '../interface'

type Props = Pick<
  PageProps<Data, SearchPageContext, SearchParams>,
  'data' | 'location' | 'pageContext'
> & {
  breadcrumb: Breadcrumb
  q: string[]
  page: number
  dictionary: CategoryDictionary
  onSearch: NonNullable<ComponentProps<typeof FilterSearchWidget>['onSearch']>
}
export function renderSearchPageWidget(layouts: readonly Layout[], props: Props) {
  return layouts.map(layout => {
    switch (layout.type) {
      case 'category': {
        return (
          <CategoryWidget key={layout.id} layout={layout as CategoryLayout} data={props.data} />
        )
      }
      case 'filterSearch': {
        return (
          <FilterSearchWidget
            key={layout.id}
            layout={layout as FilterSearchLayout}
            data={props.data}
            location={props.location}
            q={props.q}
            tags={props.pageContext?.tags || []}
            onSearch={props.onSearch}
            breadcrumbWidgetProps={{
              breadcrumb: props.breadcrumb,
              breadcrumbType: props.data.settingYaml.breadcrumbType,
              relatedCategories: props.pageContext?.relatedCategories || [],
              hierarchies: props.location.state?.hierarchies || [],
              dictionary: props.dictionary,
              topTitle: props.data.settingYaml.words?.breadcrumb?.top || 'よくあるご質問',
            }}
          />
        )
      }
      case 'filterSearchResult': {
        return (
          <FilterSearchResultWidget
            key={layout.id}
            layout={layout as FilterSearchResultLayout}
            dictionary={props.dictionary}
            data={props.data}
            q={props.q}
            page={props.page}
            onSearch={props.onSearch}
            location={props.location}
            pageContext={props.pageContext}
            botId={props.data.settingYaml.botId || ''}
            tenantId={props.data.settingYaml.tenantId || ''}
          />
        )
      }
      case 'filterCategory': {
        return (
          <FilterCategoryWidget
            key={layout.id}
            layout={layout as FilterCategoryLayout}
            dictionary={props.dictionary}
            location={props.location}
            pageContext={props.pageContext}
            q={props.q}
            data={props.data}
          />
        )
      }
      case 'html': {
        return <HtmlWidget key={layout.id} layout={layout as HtmlLayout} />
      }
      case 'iframe': {
        return <IframeWidget key={layout.id} layout={layout as IframeLayout} />
      }
      default: {
        return null
      }
    }
  })
}
